// extracted by mini-css-extract-plugin
export default {"wrapper":"OpenTickets_wrapper__ZsnN0","cardsWrapper":"OpenTickets_cardsWrapper__a+Vkf"};